<template>
  <div class="container my-5">
    <div class="row mb-3">
      <div class="col d-flex align-items-center">
        <h2 class="mb-0">Contacts</h2>
      </div>
      <div class="col-auto">
        <button type="button" class="btn btn-primary" @click="openContact(newContact())">
          <i class="far fa-plus"></i> Contact
        </button>
      </div>
    </div>

    <c-data-list :items="contacts">
      <template v-slot:columns>
        <div class="col-12 col-lg-3">
          <p>Name</p>
        </div>
        <div class="col-12 col-lg-3">
          <p>Email</p>
        </div>
        <div class="col-6 col-lg-2">
          <p>Phone</p>
        </div>
        <div class="col-6 col-lg-2">
          <p>Mobile</p>
        </div>
        <div class="col-12 col-lg-2 text-lg-end">
          <p>Notifications</p>
        </div>
      </template>
      <template v-slot:default="{ item }">
        <a href="#" @click.prevent="openContact(item)">
          <div class="row">
            <div class="col-12 col-lg-3">
              <p class="text-truncate">
                <span class="strong">{{ item.name ? item.name : '-' }}</span>
              </p>
            </div>
            <div class="col-12 col-lg-3">
              <p class="text-truncate">
                <span class="data-label d-lg-none">Email:</span>
                {{ item.email }}
              </p>
            </div>
            <div class="col-6 col-lg-2">
              <p class="text-truncate">
                <span class="data-label d-lg-none">Phone:</span>
                {{ item.phone ? item.phone : '-' }}
              </p>
            </div>
            <div class="col-6 col-lg-2">
              <p class="text-truncate">
                <span class="data-label d-lg-none">Mobile:</span>
                {{ item.mobile ? item.mobile : '-' }}
              </p>
            </div>
            <div class="col-12 col-lg-2 justify-content-lg-end">
              <span v-if="item.role_id === 1" class="badge rounded-pill bg-primary me-1">Primary</span>
              <span v-if="item.sla_notifications" class="badge rounded-pill bg-info me-1">SLA</span>
              <span v-if="item.invoice_notifications" class="badge rounded-pill bg-info">Invoice</span>
            </div>
          </div>
        </a>
      </template>
      <template v-slot:empty>
        <li class="py-4">
          <p class="text-center">No contacts for this client yet.</p>
        </li>
      </template>
    </c-data-list>

    <contact-create-modal
      ref="contactModal"
      :title="editContact.id ? 'Edit Contact' : 'Create Contact'"
      :client="client"
      :contact="editContact"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { get } from 'vuex-pathify'
import ContactCreateModal from './ContactCreateModal'

export default {
  components: {
    ContactCreateModal
  },

  data () {
    return {
      editContact: {}
    }
  },

  computed: {
    ...get('clients', ['client']),
    ...mapState('contact', { contacts: 'list' })
  },

  mounted () {
    this.getClientContacts({ id: this.client.id })
  },

  methods: {
    ...mapActions('contact', ['getClientContacts']),

    newContact () {
      return {
        sla_notifications: false,
        invoice_notifications: false
      }
    },

    openContact (contact) {
      this.editContact = contact

      // Wait for the contact prop to update before the modal clones it on open
      this.$nextTick(() => {
        this.$refs.contactModal.open()
      })
    }
  }
}
</script>
